import { AuthenticationLogItemArray } from '../../domain/authentication.log.item';
import { AdminLogItemArray } from '../../domain/admin.log.item';
import { MemberLogItemArray } from '../../domain/member.log.item';
import { UpdateLogItemArray } from '@models/domain/update.log.item';

export class LogsResponse {
    AdminLogs: AdminLogItemArray;
    MemberLogs: MemberLogItemArray;
    AuthenticationLogs: AuthenticationLogItemArray;
    UpdateLogs: UpdateLogItemArray;
}
